import Typography from "antd/lib/typography";
import React from "react";
import strings from "res/strings";

const UndefinedValue = () => {
  return <Typography.Text disabled>{strings.globals.undef}</Typography.Text>;
};

export default UndefinedValue;
